export default "__VITE_ASSET__DQeuqJkv__"